module.exports = __webpack_public_path__ + "img/dj.3962d9f0.svg";